export class ConsumerModel {
    siteId: number;
    clientId: number;
    propertyReference: string;
    consumerName: string;
    consumerAddress: string;
    consumerFromDate?: Date;
    consumerTodate?: Date;
    deviceType: string;
    closedConsumer: number;
    consumerType: string;
    vulnerable: number;
    consumerId: number;
    selected: boolean = false;
}
